document.addEventListener('DOMContentLoaded', function() {
    // Only run on desktop
    if (window.innerWidth < 990) {
      console.log('Mobile detected, not initializing arrows');
      return;
    }
    
    console.log('Product arrows script loaded');
    
    // Find the product media container - using more specific selectors based on your theme
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) {
      console.log('No media gallery found');
      return;
    }
    
    // Find the viewer inside the media gallery
    const galleryViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
    if (!galleryViewer) {
      console.log('No gallery viewer found');
      return;
    }
    
    console.log('Found gallery viewer:', galleryViewer);
    
    // Create and insert the arrow buttons directly on the gallery viewer
    const arrowContainer = document.createElement('div');
    arrowContainer.className = 'custom-product-arrows';
    arrowContainer.style.position = 'absolute';
    arrowContainer.style.top = '50%';
    arrowContainer.style.left = '0';
    arrowContainer.style.right = '0';
    arrowContainer.style.transform = 'translateY(-50%)';
    arrowContainer.style.display = 'flex';
    arrowContainer.style.justifyContent = 'space-between';
    arrowContainer.style.padding = '0 20px';
    arrowContainer.style.zIndex = '100';
    arrowContainer.style.pointerEvents = 'none';
    arrowContainer.style.width = '100%';
    
    // Create left arrow button with inline styles
    const prevButton = document.createElement('button');
    prevButton.className = 'custom-arrow-btn custom-arrow-prev';
    prevButton.setAttribute('aria-label', 'Previous image');
    prevButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15 6L9 12L15 18" stroke="white" stroke-width="2" fill="none"></path></svg>';
    prevButton.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
    prevButton.style.borderRadius = '50%';
    prevButton.style.width = '40px';
    prevButton.style.height = '40px';
    prevButton.style.display = 'flex';
    prevButton.style.alignItems = 'center';
    prevButton.style.justifyContent = 'center';
    prevButton.style.cursor = 'pointer';
    prevButton.style.border = 'none';
    prevButton.style.pointerEvents = 'auto';
    prevButton.style.boxShadow = '0 0 5px rgba(0, 0, 0, 0.3)';
    
    // Create right arrow button with inline styles
    const nextButton = document.createElement('button');
    nextButton.className = 'custom-arrow-btn custom-arrow-next';
    nextButton.setAttribute('aria-label', 'Next image');
    nextButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" fill="none"></path></svg>';
    nextButton.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
    nextButton.style.borderRadius = '50%';
    nextButton.style.width = '40px';
    nextButton.style.height = '40px';
    nextButton.style.display = 'flex';
    nextButton.style.alignItems = 'center';
    nextButton.style.justifyContent = 'center';
    nextButton.style.cursor = 'pointer';
    nextButton.style.border = 'none';
    nextButton.style.pointerEvents = 'auto';
    nextButton.style.boxShadow = '0 0 5px rgba(0, 0, 0, 0.3)';
    
    // Add buttons to container
    arrowContainer.appendChild(prevButton);
    arrowContainer.appendChild(nextButton);
    
    // Make sure the gallery viewer has position relative
    if (getComputedStyle(galleryViewer).position === 'static') {
      galleryViewer.style.position = 'relative';
    }
    
    // Add the arrow container to the gallery viewer
    galleryViewer.appendChild(arrowContainer);
    console.log('Added arrow container to gallery viewer');
    
    // Find the slider within the gallery
    const slider = galleryViewer.querySelector('ul');
    if (!slider) {
      console.log('No slider found in gallery viewer');
      return;
    }
    
    console.log('Found slider:', slider);
    
    // Find all slides
    const slides = Array.from(slider.querySelectorAll('li'));
    if (!slides.length) {
      console.log('No slides found in slider');
      return;
    }
    
    console.log(`Found ${slides.length} slides`);
    
    // Track current slide index
    let currentIndex = 0;
    
    // Find initial active slide
    slides.forEach((slide, index) => {
      if (slide.classList.contains('is-active')) {
        currentIndex = index;
      }
    });
    
    console.log(`Initial active index: ${currentIndex}`);
    
    // Function to show a specific slide
    function showSlide(index) {
      // Handle wraparound
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      
      console.log(`Showing slide ${index}`);
      
      // Simulate a click on the correct thumbnail
      const thumbnails = document.querySelectorAll('[data-target]');
      if (thumbnails && thumbnails.length > index) {
        console.log('Clicking on thumbnail:', thumbnails[index]);
        const thumbnailButton = thumbnails[index].querySelector('button');
        if (thumbnailButton) {
          thumbnailButton.click();
          currentIndex = index;
        }
      } else {
        // Fallback if thumbnails aren't found - direct slide manipulation
        slides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.add('is-active');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          }
        });
        
        // Update current index
        currentIndex = index;
        
        // Update the slider's position if it has scrolling
        if (slider.scrollTo) {
          const slideWidth = slides[0].offsetWidth;
          slider.scrollTo({
            left: index * slideWidth,
            behavior: 'smooth'
          });
        }
      }
    }
    
    // Add click handlers
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Previous button clicked');
      showSlide(currentIndex - 1);
    });
    
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Next button clicked');
      showSlide(currentIndex + 1);
    });
    
    console.log('Arrow navigation initialization complete');
  });